var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          staticClass: "el-drawer__header",
          attrs: {
            title: _vm.routeInfo.lineName,
            visible: _vm.drawerVisible,
            size: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: { "font-size": "14px", color: "#72767b" },
              attrs: { id: "route-info-line" },
            },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: "12" } }, [
                    _c("label", [_vm._v("线路名称: ")]),
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.routeInfo.lineName) },
                    }),
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["transport_route_edit"],
                              expression: "['transport_route_edit']",
                            },
                          ],
                          attrs: {
                            type: "primary",
                            size: "mini",
                            id: "edit-route-info",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.jumpUrl("/route", _vm.lineId)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: "24" } }, [
                    _c("label", [_vm._v("原城际线路: ")]),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.routeInfo.oldLineName),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: "24" } }, [
                    _c("label", [_vm._v("起点城市: ")]),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.routeInfo.startCityName),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: "24" } }, [
                    _c("label", [_vm._v("目的城市: ")]),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.routeInfo.endCityName),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: "24" } }, [
                    _c("label", [_vm._v("出发地址: ")]),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.routeInfo.startAddress),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: "24" } }, [
                    _c("label", [_vm._v("目的地址: ")]),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.routeInfo.endAddress),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: "24" } }, [
                    _c("label", [_vm._v("状态: ")]),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.routeInfo.statusStr),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: "24" } }, [
                    _c("label", [_vm._v("线路类型: ")]),
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.routeInfo.typeStr) },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: "24" } }, [
                    _c("label", [_vm._v("修改人: ")]),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.routeInfo.updateUserName),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: "24" } }, [
                    _c("label", [_vm._v("修改时间: ")]),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.routeInfo.updateTime),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: "24" } }, [
                    _c("label", [_vm._v("站点信息: ")]),
                    _vm._v(
                      "\n          线路包含" +
                        _vm._s(_vm.stationNumber) +
                        "个站点\n          "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "110px" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "routeStationTable",
                  attrs: {
                    data: _vm.routeStationList,
                    border: "",
                    "highlight-current-row": "",
                    stripe: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      type: "index",
                      width: "60",
                      label: "序号",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "类型",
                      prop: "stationType",
                      width: "120",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "站点名称",
                      prop: "stationName",
                      width: "180",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "到达时间",
                      prop: "arrTimeStr",
                      width: "140",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "里程数（公里）",
                      prop: "mileage",
                      width: "140",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              ref: "lineInfoMap",
              attrs: {
                title: _vm.lineMapTitle,
                visible: _vm.visibleLineInfoMap,
                "append-to-body": true,
                width: "80%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visibleLineInfoMap = $event
                },
              },
            },
            [
              _c("div", { staticClass: "amap-contain" }, [
                _c("div", {
                  staticClass: "map",
                  attrs: { id: "amapContainer" },
                }),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }